import { StayType } from "@b2bportal/lodging-api";
import { HotelCard } from "@tenant/hotels";
import { HomeAvailabilityCard } from "../HomeAvailabilityCard/HomeAvailabilityCard";

export const StaysAvailabilityCard = ({
  className,
  hotel,
  dateRange,
  onHover,
  rooms,
}: React.ComponentProps<typeof HotelCard>) => {
  return hotel.stayType === StayType.Homes ? (
    <HomeAvailabilityCard
      hotel={hotel}
      dateRange={dateRange}
      onHover={onHover}
      className={className}
      rooms={rooms}
    />
  ) : (
    <HotelCard
      hotel={hotel}
      dateRange={dateRange}
      onHover={onHover}
      className={className}
      rooms={rooms}
    />
  );
};
